class LeaveWordQuery {
    title
}

export default LeaveWordQuery